import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MdCheckCircle, MdErrorOutline } from 'react-icons/md';
import API from '../api';
import { useLanguage } from '../i18n';

// Landing page for the emailed confirmation link (/verify-email/:token).
// Confirming creates the organization or the staff account, then points the
// person at sign-in with their system code pre-filled.
export default function VerifyEmail() {
    const { t } = useLanguage();
    const { token } = useParams();
    const [state, setState] = useState({ status: 'loading' });
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;   // the link may only be used once
        started.current = true;
        API.post('/signup/verify', { token })
            .then(({ data }) => setState({ status: 'ok', data }))
            .catch(err => setState({ status: 'error', message: err.response?.data?.error || t('signup.verifyFailed') }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const { status, data, message } = state;
    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#edf5ff,#b8d6ff)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 18, padding: 32, boxShadow: '0 22px 48px rgba(9,32,64,.18)', textAlign: 'center' }}>
                {status === 'loading' && <><div className="spinner-border text-primary mb-3" /><p style={{ color: '#52657d' }}>{t('signup.verifying')}</p></>}
                {status === 'error' && <>
                    <MdErrorOutline size={46} style={{ color: '#dc2626' }} />
                    <p style={{ margin: '12px 0 20px', color: '#0d1b2a' }}>{message}</p>
                    <a href="/signup" className="btn btn-primary w-100">{t('signup.tryAgain')}</a>
                </>}
                {status === 'ok' && <>
                    <MdCheckCircle size={46} style={{ color: '#12b786' }} />
                    <h4 style={{ fontWeight: 700, margin: '10px 0 6px' }}>
                        {data.kind === 'organization' ? t('signup.verifyOrg', '', { org: data.organization }) : t('signup.verifyJoin', '', { org: data.organization })}
                    </h4>
                    <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 6px' }}>{t('signup.systemCode')}</p>
                    <div style={{ fontFamily: 'monospace', fontSize: 22, fontWeight: 700, background: '#f1f5f9', borderRadius: 10, padding: '10px 14px', marginBottom: 8, wordBreak: 'break-all' }}>{data.system_code}</div>
                    <p style={{ color: '#64748b', fontSize: 12.5, margin: '0 0 20px' }}>{t('signup.systemCodeNote')}</p>
                    <a href={`/login?system=${encodeURIComponent(data.system_code)}`} className="btn btn-primary w-100">{t('signup.continueSignIn')}</a>
                </>}
            </div>
        </div>
    );
}
